import { debounce } from 'lodash';
import { MdSearch } from 'react-icons/md';
import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { DateRangeSelect } from '@app/components/date-range-select/DateRangeSelect';
import { TextField } from '@app/components/form-fields/TextField';

export type TokenUsageFiltersProps = {
    updateDates: (dateRange: { start: string; end: string }) => void;
    onSearchChange: (search: string) => void;
};

const TokenUsageFilters = ({ updateDates, onSearchChange }: TokenUsageFiltersProps) => {
    return (
        <div className="form-fields-wrapper">
            <TextField
                placeholder="Search by location or parent..."
                prefix={<MdSearch size={20} />}
                onChange={debounce((e) => onSearchChange(e.target.value), 500)}
            />
            <div className="styled-table-filters">
                <StyledButtonGroup justify="flex-start">
                    <DateRangeSelect
                        pill={true}
                        dynamicMonthOptions={true}
                        totalMonthOptions={12}
                        onSelectionChange={updateDates}
                    />
                </StyledButtonGroup>
            </div>
        </div>
    );
};

export default TokenUsageFilters;
